export const all_routes = {
  SignIn: "/sign-in",
  Register: "/register",
  ResetPassword: "/reset-password",
  ForgetPassword: "/forget-password",

  ItemsIndemandledger: "/Items-In-demand-ledger",
  VehicleWisePartsSalesLedger: "/Vehicle-Wise-Parts-Sales-ledger",
  Customerwisesalesledger: "/Customer-wise-sales-ledger",
  Dailysalesledger: "/Daily-sales-ledger",
  ItemWiseSalesLedger: "/Item-Wise-Sales-Ledger",
  FastMovingItems: "/Fast-moving-items",
  SaleReporting: "/SaleReporting",
  SaleSummary: "/SaleSummary",
  DistributorDashboard: "/distributor-dashboard",
  preSalesDashboard: "/preSales-dashboard",
  ServiceDashboard: "/service-dashboard",
  PartsDashboard: "/parts-dashboard",
  partsIssue: "parts-issue",
  test: "/test",
  InvoiceOrder: "/InvoiceOrder",
  dashboard: "/",
  partsSetup: "/parts",
  technician: "/technician",
  bankSetup: "/bank",
  departmentSetup: "/department",
  makeSetup: "/make",
  modelSetup: "/model",
  colorsPartSetup: "/part-color",
  categorySetup: "/category",
  variantSetup: "/variant",
  vehicleVariantSetup: "/vehicle-variant",
  sourceSetup: "/source",
  citySetup: "/city",
  colorSetup: "/color",
  dealerSetup: "/dealer",
  userSetup: "/user",
  employeSetup: "/employees",
  companySetup: "/company",
  stockSetup: "/stock",
  itemSetup: "/vehicle",
  quotaSetup: "/quota",
  vendorSetup: "/vendors",
  taxSetup: "/taxes",
  workerTeamsSetup: "/teams",
  workerTypesSetup: "/types",
  workerShiftsSetup: "/shifts",
  Skills: "/skills",
  Transporter: "/transporter",
  Discount: "/discount",
  discountList: "/discount-list",
  Customers: "/customers",
  jobCategory: "/job-categories",
  insuranceCompanies: "/insurance-companies",
  quotaRequest: "/quota-request",
  salesmanQouta: "/salesman-qouta",
  corporateClientsSetup: "/corporate-clients",
  customerProfile: "/customer-profile",
  visiting: "/visiting",
  testDrive: "/test-drive",
  quotation: "/quotation",
  opportunity: "/opportunity",
  lead: "/lead",
  pboinquiry: "/sales-inquiry",
  PBOadd: "/sales-add",
  SalesInquiries: "/sales-inquiries",
  salesDetails: "/sales-details",
  salesDocuments: "/sales-files",
  customertransaction: "/sales-transaction",
  CancelledSales: "/Cancelled-Sales",
  InvoiceRequest: "/invoice-request",
  Payments: "/payments",
  PaymentsOE: "/payments-oe",
  cancleandchangesaleRequest: "/cancleandchangesaleRequest",
  distributorQouta: "/distributor-qouta",
  dealerQouta: "/dealer-qouta",
  //After Sales
  addAppointment: "/add-appointment",
  AddCrmAppointment: "/add-appointment",
  addVehicle: "/add-vehicle",
  crmAppointments: "/crm-appointments",
  dqirInquiries: "/dqir-inquiries",
  estimatesInquiries: "/estimates-inquiries",
  invoiceInquiries: "/invoice-inquiries",
  jobCardInquiries: "/job-card-inquiries",
  partsRequisitionInquiries: "/parts-requisition-inquiries",
  purchaseOrderInquiries: "/purchase-order-inquiries",
  warrantyInquiries: "/warranty-inquiries",
  vehicleServiceHistory: "/vehicle-service-history",
  JobCard: "/JobCard",
  JobCardDetail: "/JobCardDetail",
  workShop: "/workshop",
  WorkshopView: "/workshop-view",
  YearCalender: "/year-calender",
  JobCardInspectionDetail: "/inspection-detail",
  addPurchaseOrder: "/add-purchase-order",
  addPartsCounterSale: "/add-counter-sale",
  VehicleMasterList: "/VehicleMasterList",
  StockMovement: "/StockMovement",
  CustomersList: "/CustomersList",
  PostServiceFollowUp: "/PostServiceFollowUp",
  AppointmentReconfirmation: "/AppointmentReconfirmation",
  MrsReminders: "/mrs-reminders",
  workshopHolidays: "/holidays",
  dqirForm: "/generate-dqir",
  dqirList: "/dqir-list",
  dqirRevenue: "/dqir-revenue",
  dqirDetail: "/dqir-details",
  //Dashbaord Sub Pages
  dealersRegion: "/province-wise-report",
  dealersSalesJourney: "/sales-wise-report",
  crmRevenueReport: "/crm-revenue-report",
  jobCardCompletionReport: "/job-card-completion-report",
  technicianEfficiencyReport: "/technician-efficiency-report",
  technicianJobBreakdownReport: "/technician-job-breakdown-report",
  partsCounterSaleReport: "/parts-counter-sale-report",
  partsWorkshopSaleReport: "/parts-workshop-sale-report",
  dailyJobCardCounterReport: "/daily-jobcard-counter-report",
  lowStockReport: "/low-stock-report",
  //CRM
  CrmComplaint: "/CrmComplaint",
  CrmInquiry: "/CrmInquiry",
  CrmComplaintDetails: "/CrmComplaintDetails",
  CrmInquiryDetails: "/CrmInquiryDetails",
  CrmComplaintSetup: "/CrmComplaintSetup",
  jobCardInspections: "/job-card-inspections",
  jobCardEstimations: "/job-card-estimations",

  //Inventory
  saleItem: "/sale-item",
  purchaseItem: "/purchase-item",
  purchaseOrder: "/purchase-orders",
  StockCheckAndAdj: "/Stock-CheckAndAdj",
  PartsStockAdjustment: "/PartsStockAdjustment",
  saleOrder: "/sale-orders",
  saleOrderDetail: "/sale-orders-detail",
  purchaseOrderDetail: "/purchase-orders-detail",
  purchaseDeliveryN: "/delivery-note",
  saleDeliveryN: "/sale-delivery-note",
  purchaseDeliveryL: "/delivery-note-list",
  saleDeliveryL: "/sale-delivery-note-list",
  partsStock: "parts-stock",
  partsBin: "parts-binning",
  purchaseRE: "purchase-return",
  purchaseRELIST: "purchase-return-list",
  saleRELIST: "sale-return-list",
  saleRE: "sale-return",
  purchaseRequest: "/purchase-request",
  purchaseInvoice: "/purchase-invoice",
  purchaseInvoiceList: "/purchase-invoice-list",
  purchaseInvoiceDetail: "/purchase-invoice-detail",
  partsDemand: "/parts-demand",
  //
  partsBackOrder: "/parts-back-orders",
  partsBackOrderList: "/parts-back-orders-list",
  partsWarranty: "/parts-warranty",
  partsWarrantyList: "/parts-warranty-list",
  partsResevred: "/parts-reserved",
  partsResevredList: "/parts-reserved-list",
  partsDamaged: "/parts-damaged",
  partsDamagedList: "/parts-damaged-list",

  // Finanace
  Financial: "/financial",
  coaConfig: "/coa-config",
  codeConfig: "/code-config",
  customerLedger: "/customer-ledger",
  CompanyLedger: "/company-ledger",
  vendorPayments: "/vendors-payments",
  customerPayments: "/customers-payments",
  glChartOfAccounts: "/finance/chart-of-accounts",
  glJournalVouchers: "/finance/journal-vouchers",
  glAccountLedger: "/finance/account-ledger",
  glTrialBalance: "/finance/trial-balance",
  glProfitLoss: "/finance/profit-loss",
  glBalanceSheet: "/finance/balance-sheet",
  glCashFlow: "/finance/cash-flow",
  glFinanceIntegration: "/finance/integration",
  glPartnerBalances: "/finance/partner-balances",
  glDepositSlips: "/deposit-slips",
  glWorkshopPayments: "/job-card-payments",
  glVehicleSaleStatement: "/finance/vehicle-sale-statement",
  glWorkshopLedger: "/finance/workshop-ledger",
  glPartReturnRefunds: "/sales-return-refunds",


  productlist: "/product-list",
  addproduct: "/add-product",
  salesdashboard: "/sales-dashboard",
  brandlist: "/brand-list",
  units: "/units",
  variantyattributes: "/variant-attributes",
  warranty: "/warranty",
  barcode: "/barcode",
  alerts: "/ui-alerts",
  accordion: "/ui-accordion",
  avatar: "/ui-avatar",
  badges: "/ui-badges",
  borders: "/ui-borders",
  buttons: "ui-buttons",
  buttonsgroup: "/ui-buttons-group",
  breadcrumb: "/ui-breadcrumb",
  cards: "/ui-cards",
  dropdowns: "/ui-dropdowns",
  colors: "/ui-colors",
  carousel: "/ui-carousel",
  navtabs: "/ui-nav-tabs",
  grid: "/ui-grid",
  images: "/ui-images",
  lightbox: "/ui-lightbox",
  media: "/ui-media",
  modals: "/ui-modals",
  offcanvas: "/ui-offcanvas",
  pagination: "/ui-pagination",
  typography: "/ui-typography",
  tooltip: "/ui-tooltips",
  draganddrop: "/ui-drag-drop",
  departmentgrid: "/department-grid",
  departmentlist: "/department-list",
  designation: "/designation",
  shift: "/shift",
  attendanceemployee: "/attendance-employee",
  clipboard: "/ui-clipboard",
  popover: "/ui-popovers",
  tablebasic: "/tables-basic",
  datatable: "/data-tables",
  basicinput: "/form-basic-inputs",
  checkboxradio: "/form-checkbox-radios",
  inputgroup: "/form-input-groups",
  gridgutters: "/form-grid-gutters",
  formselect: "/form-select",
  fileupload: "/form-fileupload",
  formmask: "/form-mask",
  formhorizontal: "/form-horizontal",
  formvertical: "/form-vertical",
  floatinglabel: "/form-floating-labels",
  formvalidation: "/form-validation",
  select2: "/form-select2",

  toasts: "/ui-toasts",
  video: "/ui-video",
  sweetalerts: "/ui-sweetalerts",
  spinner: "/ui-spinner",
  progress: "/ui-progress",
  placeholder: "/ui-placeholders",
  rating: "/ui-rating",
  texteditor: "/ui-text-editor",
  counter: "/ui-counter",
  scrollbar: "/ui-scrollbar",
  stickynote: "/ui-stickynote",
  timeline: "/ui-timeline",
  apexchart: "/chart-apex",
  chartjs: "/chart-js",
  rangeslider: "/ui-rangeslider",
  fontawesome: "/icon-fontawesome",
  feathericon: "/icon-feather",
  ionicicons: "/icon-ionic",
  materialicons: "/icon-material",
  pe7icons: "/icon-pe7",
  simpleline: "/icon-simpleline",
  themifyicons: "/icon-themify",
  iconweather: "/icon-weather",
  typicons: "/icon-typicon",
  flagicons: "/icon-flag",
  ribbon: "/ui-ribbon",

  chat: "/chat",
  videocall: "/video-call",
  audiocall: "/audio-call",
  email: "/email",
  callhistory: "/call-history",
  todo: "/todo",
  wizard: "/form-wizard",
  expiredproduct: "/expired-products",
  lowstock: "/low-stocks",
  categorylist: "/category-list",
  subcategories: "/sub-categories",
  productdetails: "/product-details",
  editproduct: "/edit-product",
  expenselist: "/expense-list",
  expensecategory: "/expense-category",
  calendar: "/calendar",
  variantattributes: "/variant-attributes",
  qrcode: "/qrcode",
  purchaselist: "/purchase-list",
  purchaseorderreport: "/purchase-order-report",
  purchasereturn: "/purchase-returns",
  appearance: "/appearance",
  socialauthendication: "/social-authentication",
  languagesettings: "/language-settings",
  invoicesettings: "/invoice-settings",
  printersettings: "/printer-settings",
  possettings: "/pos-settings",
  customfields: "/custom-fields",
  emailsettings: "/email-settings",
  smssettings: "/sms-gateway",
  otpsettings: "/otp-settings",
  gdbrsettings: "/gdpr-settings",
  paymentgateway: "/payment-gateway-settings",
  banksettingslist: "/bank-settings-list",
  banksettingsgrid: "/bank-settings-grid",
  taxrates: "/tax-rates",
  currencysettings: "/currency-settings",
  storagesettings: "/storage-settings",
  banipaddress: "/ban-ip-address",
  generalsettings: "/general-settings",
  securitysettings: "/security-settings",
  notification: "/notification",
  connectedapps: "/connected-apps",
  systemsettings: "/system-settings",
  companysettings: "/company-settings",
  localizationsettings: "/localization-settings",
  prefixes: "/prefixes",
  preference: "/preference",
  saleslist: "/sales-list",
  invoicereport: "/invoice-report",
  salesreturn: "/sales-returns",
  quotationlist: "/quotation-list",
  pos: "/pos",
  attendanceadmin: "attendance-admin",
  payslip: "/payslip",
  holidays: "/holidays",
  customers: "/customers",
  suppliers: "/suppliers",
  storelist: "/store-list",
  managestock: "/manage-stocks",
  stockadjustment: "/stock-adjustment",
  stocktransfer: "/stock-transfer",
  salesreport: "/sales-report",
  purchasereport: "/purchase-report",
  inventoryreport: "/inventory-report",
  supplierreport: "/supplier-report",
  customerreport: "/customer-report",
  expensereport: "/expense-report",
  incomereport: "/income-report",
  taxreport: "/tax-report",
  profitloss: "/profit-loss-report",
  notes: "/notes",
  filemanager: "/file-manager",
  profile: "/profile",
  signin: "/signin",
  signintwo: "/signin-2",
  signinthree: "/signin-3",
  register: "/register",
  registerTwo: "/register-2",
  registerThree: "/register-3",
  forgotPassword: "/forgot-password",
  forgotPasswordTwo: "/forgot-password-2",
  forgotPasswordThree: "/forgot-password-3",
  resetpassword: "/reset-password",
  resetpasswordTwo: "/reset-password-2",
  resetpasswordThree: "/reset-password-3",
  emailverification: "/email-verification",
  emailverificationTwo: "/email-verification-2",
  emailverificationThree: "/email-verification-3",
  twostepverification: "/two-step-verification",
  twostepverificationTwo: "/two-step-verification-2",
  twostepverificationThree: "/two-step-verification-3",
  lockscreen: "/lock-screen",
  error404: "/error-404",
  error500: "/error-500",
  blankpage: "/blank-page",
  comingsoon: "/coming-soon",
  undermaintenance: "/under-maintenance",
  users: "/users",
  rolesSetup: '/roles',
  UsersSetup: '/user-setup',
  Privileges: '/privileges',
  RolesSetup: '/roles-setup',
  Module: '/module',
  Screen: '/screen',
  subScreen: '/sub-screen',
  masterSetupScreen: '/auth-setup',
  rolespermission: "/roles-permissions",
  permissions: "/permissions",
  deleteaccount: "/delete-account",
  employeegrid: "/employees-grid",
  addemployee: "/add-employee",
  editemployee: "/edit-employee",
  leavesadmin: "leaves-admin",
  leavesemployee: "/leaves-employee",
  leavestype: "/leave-types",
  warehouses: "/warehouse",
  coupons: "/coupons",
  quotationDetails: '/quotation-details',
  leadDetails: "/Lead-details",

  /* HR & Payroll */
  hrDashboard: "/hr-dashboard",
  hrEmployees: "/hr-employees",
  hrEmployeeProfile: "/hr-employee-profile",
  hrDailyAttendance: "/hr-daily-attendance",
  hrAttendanceImport: "/hr-attendance-import",
  hrMonthlyAttendance: "/hr-monthly-attendance",
  hrLeaveRequests: "/hr-leave-requests",
  hrLeaveBalances: "/hr-leave-balances",
  hrSalaryStructure: "/hr-salary-structure",
  hrLoans: "/hr-loans",
  hrIncentives: "/hr-incentives",
  hrPayrollRuns: "/hr-payroll-runs",
  hrPayrollRunDetail: "/hr-payroll-run",
  hrPayslips: "/hr-payslips",
  hrFinalSettlement: "/hr-final-settlement",
  hrReports: "/hr-reports",
  hrDesignations: "/hr-designations",
  hrGrades: "/hr-grades",
  hrLeaveTypes: "/hr-leave-types",
  hrPayComponents: "/hr-pay-components",
  hrTaxSlabs: "/hr-tax-slabs",
  hrPayrollSettings: "/hr-payroll-settings",
  customerJourney: "/customer-journey",
  pdsRequests: "/pds-requests",
  preSalesPerformanceReport: "/presales-performance-report",
  partsTargetVsInvoiceReport: "/parts-target-vs-invoice-report",
  appointmentsVsVisitorsReport: "/appointments-vs-visitors-report",
  workshopRevenueReport: "/workshop-revenue-report",
  dealerVehicleTargetReport: "/dealer-vehicle-target-report",
  modelWiseBookingReport: "/model-wise-booking-report",
  customerComplaintsReport: "/customer-complaints-report",
  jobCardsCashVsCreditReport: "/jobcards-cash-vs-credit-report",
  partsRequestsReport: "/parts-requests-report"
};
